
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Number_input","data-name":"Number input","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"id":"Rectangle_15296","data-name":"Rectangle 15296","width":"30","height":"30","fill":"none"}}),_c('g',{attrs:{"id":"Group_45484","data-name":"Group 45484"}},[_c('g',{attrs:{"id":"Group_45489","data-name":"Group 45489"}},[_c('path',{attrs:{"id":"Path_32699","data-name":"Path 32699","d":"M22.57 8.1H7.43a3.73 3.73 0 00-3.73 3.721v6.358a3.73 3.73 0 003.73 3.726h15.14a3.73 3.73 0 003.73-3.726v-6.358A3.73 3.73 0 0022.57 8.1m2.23 10.079a2.228 2.228 0 01-2.226 2.226H7.43a2.228 2.228 0 01-2.23-2.226v-6.358A2.228 2.228 0 017.43 9.6h15.14a2.228 2.228 0 012.23 2.221z"}}),_c('path',{attrs:{"id":"Path_32700","data-name":"Path 32700","d":"M21.461 16.1l-1.337 1.284-1.274-1.27a.75.75 0 00-1.06 1.06l1.793 1.79a.747.747 0 00.53.22.752.752 0 00.52-.209l1.867-1.794a.751.751 0 00-1.039-1.081"}}),_c('path',{attrs:{"id":"Path_32701","data-name":"Path 32701","d":"M20.74 11.037a.747.747 0 00-.53-.22.752.752 0 00-.52.209l-1.871 1.792a.751.751 0 001.043 1.082l1.338-1.283 1.269 1.27a.75.75 0 001.06-1.06z"}}),_c('path',{attrs:{"id":"Path_32702","data-name":"Path 32702","d":"M8.763 11.311H7.532a.75.75 0 100 1.5h.481v5.128a.75.75 0 001.5 0v-5.878a.75.75 0 00-.75-.75"}})])])])
          )
        }
      }
    